import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { ShippedItem } from "../../types/traceability";
import { kgFmt, lbsFmt, pcsFmt } from "../../shared/formatting";

interface ShippedItemsTableProps {
  items: ShippedItem[];
}

export default function ShippedItemsTable({ items }: ShippedItemsTableProps) {
  return (
    <DataTable
      value={items}
      dataKey="id"
      responsiveLayout="scroll"
      size="small"
      className="p-datatable-sm"
      emptyMessage="No shipped items found"
    >
      <Column
        header="Customer"
        body={(r: ShippedItem) => r.order.customer_name ?? "—"}
      />
      <Column
        header="Invoice Number"
        body={(row: ShippedItem) => row.order?.invoice_number ?? "—"}
      />
      <Column
        header="Total kg"
        body={(r: ShippedItem) => kgFmt(r.total_in_kg)}
        style={{ minWidth: 120 }}
      />
      <Column
        header="Total lbs"
        body={(r: ShippedItem) => lbsFmt(r.total_in_lbs)}
        style={{ minWidth: 120 }}
      />
      <Column
        header="Total pcs"
        body={(r: ShippedItem) => pcsFmt(r.total_in_pieces)}
        style={{ minWidth: 120 }}
      />
      <Column
        header="Order"
        body={(r: ShippedItem) => (
          <button
            type="button"
            className="text-blue-600 hover:text-blue-800 text-sm font-medium"
            onClick={() => window.open(`/shipments/${r.order_id}`, "_blank")}
          >
            View Order
          </button>
        )}
        style={{ minWidth: 120 }}
      />
    </DataTable>
  );
}
